import { ReactNode, useState } from 'react';
import { Box, Toolbar } from '@mui/material';
import SideMenu, { DRAWER_WIDTH } from '@/components/Layout/SideMenu';
import TopBar from '@/components/Layout/TopBar';
import LayoutFooter from '@/components/Layout/LayoutFooter';

export default function AppLayout({ children }: { children: ReactNode }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <TopBar onMenuClick={() => setMobileOpen(true)} />
      <SideMenu
        variant="temporary"
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
      />
      <SideMenu variant="persistent" open={false} onClose={() => {}} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: { md: `calc(100% - ${DRAWER_WIDTH}px)` },
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Toolbar />
        <Box
          sx={{
            flex: 1,
            px: { xs: 2, sm: 3 },
            py: { xs: 2, sm: 3 },
            width: '100%',
          }}
        >
          {children}
        </Box>
        <LayoutFooter />
      </Box>
    </Box>
  );
}
